import React from "react";
import PropTypes from "prop-types";
import FeatureChecklist from "./FeatureChecklist"; // шлях підкоригуй за своїм деревом

export default function FeatureSettingsMenu({ fmgr, className = "", loadForest }) {
    const [open, setOpen] = React.useState(false);
    const btnRef = React.useRef(null);
    const panelRef = React.useRef(null);

    // Закриття по Escape
    React.useEffect(() => {
        if (!open) return;
        const onKey = (e) => {
            if (e.key === "Escape") setOpen(false);
        };
        document.addEventListener("keydown", onKey, true);
        return () => document.removeEventListener("keydown", onKey, true);
    }, [open]);

    // Клік поза меню закриває його
    React.useEffect(() => {
        if (!open) return;
        const onDown = (e) => {
            if (panelRef.current?.contains(e.target)) return;
            if (btnRef.current?.contains(e.target)) return;
            setOpen(false);
        };
        document.addEventListener("mousedown", onDown, true);
        return () => document.removeEventListener("mousedown", onDown, true);
    }, [open]);

    const toggle = () => setOpen((v) => !v);

    return (
        <div className={`relative ${className}`}>
            <button
                ref={btnRef}
                type="button"
                onClick={toggle}
                aria-expanded={open ? "true" : "false"}
                aria-haspopup="menu"
                className={[
                    "inline-flex items-center justify-center",
                    "h-9 w-9 rounded-md border p-0",
                    "bg-white text-gray-700 shadow-sm hover:bg-gray-50",
                    "focus:outline-none focus:ring-2 focus:ring-blue-500/50",
                    "dark:bg-neutral-900 dark:text-gray-200 dark:hover:bg-neutral-800",
                ].join(" ")}
                title="Налаштування перегляду"
            >
                <svg
                    viewBox="0 0 24 24"
                    className="block w-5 aspect-square"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    preserveAspectRatio="xMidYMid meet"
                    vectorEffect="non-scaling-stroke"
                    aria-hidden="true"
                >
                    <path d="M13.85 22.25h-3.7c-.74 0-1.36-.54-1.45-1.27l-.27-1.89c-.27-.14-.53-.29-.79-.46l-1.8.72c-.7.26-1.47-.03-1.81-.65L2.2 15.53c-.35-.66-.2-1.44.36-1.88l1.53-1.19c-.01-.15-.02-.3-.02-.46 0-.15.01-.31.02-.46l-1.52-1.19c-.59-.45-.74-1.26-.37-1.88l1.85-3.19c.34-.62 1.11-.9 1.79-.63l1.81.73c.26-.17.52-.32.78-.46l.27-1.91c.09-.7.71-1.25 1.44-1.25h3.7c.74 0 1.36.54 1.45 1.27l.27 1.89c.27.14.53.29.79.46l1.8-.72c.71-.26 1.48.03 1.82.65l1.84 3.18c.36.66.2 1.44-.36 1.88l-1.52 1.19c.01.15.02.3.02.46s-.01.31-.02.46l1.52 1.19c.56.45.72 1.23.37 1.86l-1.86 3.22c-.34.62-1.11.9-1.8.63l-1.8-.72c-.26.17-.52.32-.78.46l-.27 1.91c-.1.68-.72 1.22-1.46 1.22z" />
                    <circle cx="12" cy="12" r="2.5" />
                </svg>
            </button>
            {/* Меню — випадає праворуч зверху (правий верхній кут хедера) */}
            {open && (
                <div
                    ref={panelRef}
                    role="menu"
                    className={[
                        "absolute right-0 mt-2 w-[min(92vw,420px)] origin-top-right",
                        "rounded-xl p-2  dark:bg-neutral-900 z-50",  /*  */
                    ].join(" ")}
                >
                    <FeatureChecklist
                        fmgr={fmgr}
                        loadForest={loadForest}
                        setOpen={setOpen}
                    />
                </div>
            )}
        </div>
    );
}

FeatureSettingsMenu.propTypes = {
    fmgr: PropTypes.object.isRequired,
    className: PropTypes.string,
    loadForest: PropTypes.func,
};
